export default __webpack_public_path__ + "static/media/BenefiThree.ebe1719d.svg";